import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchTurnout, fetchPublicCampaigns } from '../../lib/api';

export function useTurnoutData(campaignId, token) {
  return useQuery({
    queryKey: queryKeys.turnout(campaignId, token),
    queryFn: () => fetchTurnout(campaignId, token),
    enabled: !!campaignId,
  });
}

export function usePublicCampaigns() {
  return useQuery({
    queryKey: queryKeys.publicCampaigns(),
    queryFn: fetchPublicCampaigns,
  });
}
